import { render, staticRenderFns } from "./RequestPDF.vue?vue&type=template&id=8a034056"
import script from "./RequestPDF.vue?vue&type=script&lang=js"
export * from "./RequestPDF.vue?vue&type=script&lang=js"
import style0 from "./RequestPDF.vue?vue&type=style&index=0&id=8a034056&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports